// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tags_wrapper__3tVpW","toolbar":"tags_toolbar__2-yLy","tableWrapper":"tags_tableWrapper__1NT5m"};